import { BaseEntity } from "@app/models/rest/base-entity";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";

@HateoasResource("webhookDefinitions")
export class WebhookDefinition extends BaseEntity {
  name: string;
  url: string;
  authType: string;
  auth: string;
  enabled: boolean;
  retryInterval: number;
  retryMaximum: number;

  retainLog: boolean;

  visitCreation: boolean;
  visitBooking: boolean;
  visitCancellation: boolean;
  visitCompletion: boolean;
  visitUpdate: boolean;
  visitStatusChange: boolean;

  jobCreation: boolean;
  jobStatusChange: boolean;
  jobUpdate: boolean;
  ticketDespatched: boolean;
  autoDespatchOnly: boolean;
  // private List<WebhookStaging> stagingList;
}
